const getOptions = (status: string) => {
    const options = {
        PO: [
            {
                label: 'Purchase Orders',
                value: 'PurchaseOrders',
                SelectionDisabled: true,
                children: [
                    {
                        label: 'Lines',
                        value: 'Lines',
                        disabled: status?.toLowerCase() === 'x',
                    },
                    {
                        label: 'Purchase Order Details',
                        value: 'PurchaseOrderDetails',
                        disabled: status?.toLowerCase() === 'x',
                    },
                    {
                        label: 'Delivery',
                        value: 'Delivery',
                        disabled: status?.toLowerCase() === 'x',
                    }
                ]
            },
            {
                label: 'Commit',
                value: 'Commit',
                SelectionDisabled: status?.toLowerCase() === 'x'
            },
            {
                label: 'Diary',
                value: 'PurchaseOrdersDiary',
            },
            {
                label: 'Notepad',
                value: 'PurchaseOrdersNotepad',
                hideInV2: true
            }
        ]
    };

    return options;
};

export default getOptions;
